import { Component, OnInit , ViewChild, TemplateRef, ElementRef} from '@angular/core';
import { BlocklyEditComponent } from './../blockly-edit/blockly-edit.component';
import { FormulasService } from '../../../services/formulas.service';
import { ErroresService } from '../../../core/services/errores.service';

@Component({
  selector: 'blockly',
  templateUrl: './blockly.component.html',
  styleUrls: ['./blockly.component.css']
})
export class BlocklyComponent implements OnInit{

  public nav:any;
  formulasList:any;
  formulaActual: any = null;
  verDetalle: boolean = false;
  permisoEdicion: boolean = false;

  buscando: boolean;
  
  @ViewChild('ChildFormulaEdit') formulaDetalle: BlocklyEditComponent;

  public constructor(private formulasService: FormulasService,
                     private erroresService: ErroresService) {
  }

  ngOnInit() {
    //console.log(this.workspace);
    this.retrieveXMLFormulas();
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Formulas")) this.permisoEdicion = true;
  }

  retrieveXMLFormulas(): void {
    this.buscando = true;
    this.formulasService.getFormulas()
      .subscribe(
        data => {
          this.formulasList = data;
          this.buscando = false;
        },
        error => {
          this.erroresService.MostrarErrorByStatus(error, "Error al consultar");
          this.buscando = false;
        });
  }
  
  OnVisualizarDetalle(formulaActual)
  {
    this.verDetalle = true;
    this.formulaActual = formulaActual;
  }

  OnVisualizarLista()
  {
    this.verDetalle = false;
    this.retrieveXMLFormulas();
  }

}